import { SVGProps } from 'react';
import Icon from '../../Icon';

/** Fills its wrapper (LineRoundedWrapper sets the size); `stroke` sets the colour. */
const LineRoundedPencil = ({ stroke, color }: SVGProps<SVGElement>) => (
  <Icon name="edit" size="100%" color={stroke ?? color} />
);

export { LineRoundedPencil };
